import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "App";
import * as serviceWorker from "serviceWorker";
import "./assests/font-awesome/css/all.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = createRoot(rootElement);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
